import React, { useState } from 'react';

import Header from '../layout/header/header.component';
import SideBar from '../layout/side_bar/side_bar.component';
import Footer from '../layout/footer/footer.component';
import FeedbackForm from '../presentational/common/feedback_form/feedback_form.component';
import './error_page.component.css';
import { Button } from 'react-bootstrap';

const ErrorPage = () => {
  const [showContactus, setShowContactus] = useState(false);

  return (
    <>
      <Header />
      <SideBar />
      <section className="error_page__content">
        <h4>
          Sorry! Something went wrong, and we are working on it. <br /> Please
          try again reloading the page or get in touch with us.
        </h4>
        <Button
          type="button"
          variant="primary"
          onClick={() => setShowContactus(true)}
          className="mt-3"
        >
          Contact us
        </Button>
      </section>
      <Footer />
      <FeedbackForm show={showContactus} setShow={setShowContactus} />
    </>
  );
};

export default ErrorPage;
